<!-- src/components/layout/Layout.svelte -->
<script>
  import Header from './Header.svelte';
  import Footer from './Footer.svelte';
  import { is_subscribed_store } from '../../lib/stores.js';
  import { is_subscribed } from '../../lib/cookies.js';
  import { onMount } from 'svelte';

  // Initialize the store with the cookie value on mount
  onMount(() => {
    is_subscribed_store.set(is_subscribed());
  });
</script>

<div class="layout">
  <Header />
  
  <main class="main_content">
    <slot />
  </main>
  
  <Footer />
</div>

<style>
  .layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .main_content {
    flex: 1;
    padding-top: 72px; /* Height of the fixed header */
  }
</style> 